"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var sizeStyle = function sizeStyle(props) {
  var data = props.theme.heading[props.level];

  if (data) {
    return (0, _styledComponents.css)(["font-size:", ";font-weight:", ";@media (min-width:768px){flex-direction:column;font-size:", ";}"], data.size, data.weight, data.media.min768.size);
  }

  return '';
};

var setColor = function setColor(props) {
  var color = props.theme.colors.black;

  if (props.primary) {
    color = props.theme.colorPrimary;
  }

  if (props.secondary) {
    color = props.theme.colorSecondary;
  }

  return (0, _styledComponents.css)(["color:", ""], color);
};

var textAlignStyle = (0, _styledComponents.css)(["text-align:", ";"], function (props) {
  return props.textAlign;
});
var truncateStyle = "\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n";

var H1 = _styledComponents["default"].h1.withConfig({
  displayName: "Heading__H1",
  componentId: "sc-370qqr-0"
})(["", " ", ";", " ", " ", ""], function (props) {
  return sizeStyle(props);
}, function (props) {
  return setColor(props);
}, function (props) {
  return props.textAlign && textAlignStyle;
}, function (props) {
  return props.truncate && truncateStyle;
}, function (props) {
  return props.uppercase && "\n      text-transform: uppercase;\n    ";
});

var Heading = function Heading(props) {
  var level = props.level;
  if (!level) level = 1;
  return /*#__PURE__*/_react["default"].createElement(H1, _extends({
    as: "h".concat(level)
  }, props));
};

var _default = Heading;
exports["default"] = _default;